import { bluePalette } from '../../themes/colors';
import { bluePaletteDark, grayPaletteDark } from '../../themes/dark-colors';

export const toggleDarkTheme = {
  backgroundColor: {
    on: bluePalette[800],
    off: grayPaletteDark[400],
    disabled: grayPaletteDark[300],
    hover: {
      on: bluePalette[900],
      off: grayPaletteDark[500],
    },
  },
  focusColor: bluePaletteDark[400],
  circle: {
    backgroundColor: grayPaletteDark[0],
  },
};
